import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Linkedin } from 'react-feather';
import { useTranslation } from 'react-i18next';


import Section from '../shared/Section';
import { routesLang } from './LangGuard';
import { siteLangs, translateTail } from './TranslateRoutes';

const allowedLangs = ['en', 'fr', 'es'] as const;

const LanguageRedirect = ({ showContent = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    //const pathSegments = location.pathname.split('/').filter(Boolean);
    //const pathLang = pathSegments[0];
    //const currentPath = pathSegments[1];

    useEffect(() => {
        const segments = location.pathname.split('/').filter(Boolean);
        const first = segments[0];
        const preferred = (localStorage.getItem('lang') ?? navigator.language?.split('-')[0] ?? 'en').toLowerCase();

        const lang = allowedLangs.includes(first as any) ? (first as typeof allowedLangs[number]) :
            (allowedLangs.includes(preferred as any) ? (preferred as typeof allowedLangs[number]) : 'en');

        let tail: string[] = segments.slice(allowedLangs.includes(first as any) ? 1 : 0);
        const targetPath = '/' + [lang, ...tail].join('/');

        if (location.pathname !== targetPath) {
            if (i18n.language !== lang) i18n.changeLanguage(lang).catch(() => { });
            navigate(targetPath, { replace: true });
            return;
        }

        // Route fourre-tout : le prefixe de langue est bon mais le chemin n'existe pas dans les routes
        // chargees (ex. /en/accueil). Sans redirection, la page "Redirection" resterait figee.
        if (showContent && allowedLangs.includes(first as any)) {
            for (const other of siteLangs) {
                if (other === routesLang) continue;
                const translated = translateTail(tail, other, routesLang);
                if (translated.join('/') !== tail.join('/')) {
                    navigate('/' + [routesLang, ...translated].join('/') + location.search + location.hash, { replace: true });
                    return;
                }
            }
            navigate('/' + routesLang, { replace: true });
        }

        //const preferredLang = localStorage.getItem("lang") ?? navigator.language?.split("-")[0] ?? "en";
        //if (pathLang !== undefined && currentPath !== undefined) {
        //    navigate(`/${pathLang}/${currentPath}`, { replace: true });
        //    if (pathLang !== preferredLang) {
        //        window.location.reload();
        //    }
        //} else if (pathLang !== undefined && currentPath === undefined) {
        //    navigate(`/${pathLang}`, { replace: true });
        //} else {
        //    navigate(`/${preferredLang}`, { replace: true });
        //}
    }, [location.pathname, navigate, i18n, showContent]);

    // [navigate, pathLang, currentPath]

    return <>
        <Section className="section-society top-section" style={{ backgroundColor: "white", paddingBottom: "0px" }}>
            <Row className='section-society py4'>
                <Col lg={0} >
                    <div className="smedia-sidebar">
                        <div className="smedia-content">
                            <a href="https://www.linkedin.com/company/flowly1/" target="_blank" rel="noreferrer">
                                <span className="smedia-sidebar"><Linkedin size="18" /></span>
                                <span className="smedia-divider"></span>
                                <span className="smedia-text">{t("NavBar.FollowUs")}</span>
                            </a>
                        </div>
                    </div>
                </Col>
                <Col lg={8} xs={12}>
                    <h2 dangerouslySetInnerHTML={
                        { __html: t('Routes.Redirection')! }
                    } />

                    <p dangerouslySetInnerHTML={
                        { __html: t('Routes.LinkToHome')! }
                    } />
                </Col>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
            </Row>
        </Section>
    </>;
};

export default LanguageRedirect;